import React from "react";
import ME from "../../assets/rominaCV1.jpg";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <h5 className="text-title">Some</h5>
      <h2 className="text-subtitle">Who am I?</h2>
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="flex justify-center items-center">
          <div className="relative w-80 h-80 rounded-2xl overflow-hidden border-2 border-secondary bg-cover bg-center">
            <img src={ME} alt="noe" className="w-full h-full object-cover" />
          </div>
        </div>

        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            <article className="about__card">
              <FaAward className="about__icon " />
              <h5 className="about_title">Bootcamp</h5>
              <small className="about_subtitle">800+ Hours</small>
            </article>
            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5 className="about_title">Team work</h5>
              <small className="about_subtitle">Projects</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5 className="about_title">Individual</h5>
              <small className="about_subtitle">Projects</small>
            </article>
          </div>
          <p className="font-semibold text-gray-600 mb-8 text-center md:text-left mx-6 md:mx-0">
            Innovative programmer who strives to make the world a connected place. 
            An ingenious thinker, adept at software development and working with diverse data structures. 
            Proficient in various platforms, languages and integrated systems. Able to effectively self-manage 
            during independent projects, as well as collaborate as part of a productive team.
            <br /> <br/>Why me?<br />
            I consider myself a creative learner, 
            with the ability to adapt to new technologies and tools in a short time.
          </p>
          <a href="#contact" className="btn-home bg-aqua text-dark py-3 px-7 transition-all ml-[140px] md:ml-0 font-semibold">
            Lets Talk!
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
